<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1271px' }">
      <v-layout row wrap>
        <v-flex xs12 md12 lg12>
          <h2 class="head mb-32 pt-40">
            Partners
          </h2>
          <v-card class="base-card">
            <v-card-text>
              <PartnerCustomers></PartnerCustomers>
              <Payouts :payments-for-user-with-token="true"></Payouts>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}
.theme--light h2.head {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: left;
  letter-spacing: 0.02em;
  color: #103a84;
}
>>> .theme--light .main-card {
  box-shadow: none !important;
  border-radius: 0 !important;
}
.theme--light .base-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px 15px 15px 15px;
}
/**************************************/
.theme--dark h2.head {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: left;
  letter-spacing: 0.02em;
  color: #ffffff;
}
.theme--dark .main-card {
  box-shadow: none !important;
  border-radius: 0px !important;
}
.theme--dark .base-card {
  background: #212121;
  box-shadow: none;
  border-radius: 15px 15px 15px 15px;
}
</style>
<script>
import PartnerCustomers from "../components/partners/PartnerCustomers";
import Payouts from "../components/whitelabel/Payouts";
import {mapGetters} from "vuex";

export default {
  components: {
    PartnerCustomers,
    Payouts
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    })
  },
  created() {
    if (
      !this.user.allow_partners_page &&
      this.user.allow_partners_page !== true
    ) {
      this.$router.push({ name: "dashboard" });
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/partners.vue